export default {
  list: [
    {
      title: 'مشتری',
      value: 'CLINET_MESSAGE'
    },
    {
      title: 'اپراتور',
      value: 'RSEE_RESPONSE'
    }
  ],

  values: {
    CLINET_MESSAGE: 'CLINET_MESSAGE',
    RSEE_RESPONSE: 'RSEE_RESPONSE'
  }

}